module.exports = __webpack_public_path__ + "1-07.png?de07bc5908b883b38499219b1a0f3485";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-07.png
// module id = 84
// module chunks = 0